import React from 'react';
import PropTypes from 'prop-types';
import './Breadcrumbs.sass';


const BreadcrumbItem = ({ title, url, active }) => (
  <li className="breadcrumbs-list">
    {active ? <span className="last-list">{title}</span> : <a href={url}>{title}</a>}
  </li>
);

BreadcrumbItem.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  active: PropTypes.bool,
};

BreadcrumbItem.defaultProps = {
  title: '',
  url: '',
  active: false,
};


export default BreadcrumbItem;
